var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CButton',_vm._b({staticClass:"py-0 mb-2",attrs:{"color":"dark","variant":"outline"},on:{"click":_vm.handleDownloadQrCode}},'CButton',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.$t('common.qrCode')))])}
var staticRenderFns = []

export { render, staticRenderFns }